module.exports = __webpack_public_path__ + "img/m_ic_sns_facebook.4b6bf184.svg";